'use client';

import { OrgAnalyticsDashboard } from '@/components/analytics/org-analytics-dashboard';
import { useOrgAnalytics } from '@/hooks/use-director-data';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

export default function DirectorAnalyticsPage() {
  const { data, isLoading, error } = useOrgAnalytics();

  if (error) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Analytics</h1>
          <p className="text-muted-foreground">Organization-wide evaluation trends and insights</p>
        </div>
        <Card>
          <CardContent className="py-8">
            <p className="text-red-600 text-center">
              Failed to load analytics. Please try again later.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <BarChart3 className="w-7 h-7 text-purple-600" />
          Analytics
        </h1>
        <p className="text-muted-foreground">Organization-wide evaluation trends and insights</p>
      </div>

      {/* Analytics Dashboard */}
      {isLoading ? (
        <div className="space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-24 w-full" />
            ))}
          </div>
          <Skeleton className="h-96 w-full" />
          <div className="grid md:grid-cols-2 gap-6">
            <Skeleton className="h-64 w-full" />
            <Skeleton className="h-64 w-full" />
          </div>
        </div>
      ) : data ? (
        <OrgAnalyticsDashboard
          overallStats={data.overallStats}
          chartData={data.chartData}
          topPerformers={data.topPerformers}
          needsAttention={data.needsAttention}
        />
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>No Data Available</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500 text-center py-8">
              No evaluation data available yet. Analytics will appear as coaches create evaluations.
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
